export default __webpack_public_path__ + "static/media/shop-header.00ba1d31.jpg";